<div *ngIf="hasAgrement" ngbAccordion style="padding: 10px">
  <div ngbAccordionItem [collapsed]="isColapsed">
    <h2 ngbAccordionHeader>
      <button id="agreement-details-accordion" ngbAccordionButton>
        Ver detalles del Acuerdo Comercial
      </button>
    </h2>
    <div ngbAccordionCollapse>
      <div ngbAccordionBody class="table-container">
        <ng-template>
          <table class="table table-hover">
            <caption>
              Detalles del Acuerdo Comercial
            </caption>
            <tbody>
              <tr>
                <th scope="row">Fecha de Inicio</th>
                <td>
                  {{ agreement.startTime | date : "dd-MM-YYYY  HH:mm" : "UTC" }}
                </td>
              </tr>
              <tr>
                <th scope="row">Fecha de Término</th>
                <td>
                  {{ agreement.endTime | date : "dd-MM-YYYY  HH:mm" : "UTC" }}
                </td>
              </tr>
              <tr>
                <th scope="row">Tipo de Acuerdo</th>
                <td>
                  {{ agreement.type | master : "COMMERCIALAGREEMENT#TYPES" }}
                </td>
              </tr>
              <tr>
                <th scope="row">Garantizado</th>
                <td>
                  {{
                    (agreement.guaranteed ?? 0) > 0
                      ? (agreement.guaranteed | number)
                      : ""
                  }}
                  -
                  {{ agreement.guaranteedUoM }}
                </td>
              </tr>
              <tr>
                <th scope="row">Porcentaje Adicional</th>
                <td>
                  {{
                    (agreement.additionalPercentage ?? 0) > 0
                      ? (agreement.additionalPercentage * 100
                          | number : "1.0-0") + "%"
                      : ""
                  }}
                </td>
              </tr>
              <tr>
                <th scope="row">¿Es Ajustable?</th>
                <td>{{ agreement.adjustable ? "Sí" : "No" }}</td>
              </tr>
              <tr>
                <th scope="row">Creado por</th>
                <td>{{ agreement.createdBy }}</td>
              </tr>
              <tr>
                <th scope="row">Actualizado por</th>
                <td>{{ agreement.updatedBy }}</td>
              </tr>
              <tr>
                <th scope="row">Fecha de Creación</th>
                <td>
                  {{ agreement.createdAt | date : "dd-MM-YYYY  HH:mm" }}
                </td>
              </tr>
              <tr>
                <th scope="row">Fecha de Actualización</th>
                <td>
                  {{ agreement.updatedAt | date : "dd-MM-YYYY  HH:mm" }}
                </td>
              </tr>
            </tbody>
          </table>
          <form [formGroup]="form">
            <div class="scrollable-table-container">
              <table class="table table-bordered table-striped">
                <caption>
                  detalle Acuerdo Comercial
                </caption>
                <thead>
                  <tr>
                    <th colspan="2" class="text-center" id="ac-work-shifts">
                      Turnos de trabajo
                    </th>
                  </tr>
                  <tr>
                    <th id="ac-work-time-title">Hora inicio - Hora Fin</th>
                    <th id="tanque-ac-days-of-work-title">
                      <div
                        class="d-flex flex-wrap gap-3 justify-content-center"
                      >
                        <div
                          *ngFor="let day of days"
                          class="text-center"
                          style="width: 10px"
                        >
                          <div>
                            <strong>{{
                              day.valueToDisplay.toUpperCase()
                            }}</strong>
                          </div>
                        </div>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody formArrayName="workShifts">
                  <tr
                    *ngFor="let shift of workShifts.controls; let i = index"
                    [formGroupName]="i"
                  >
                    <th class="text-center" id="ac-work-time">
                      <label
                        ><strong>
                          {{
                            shift.get("startTime")?.value.slice(0, 5)
                          }}</strong
                        >
                        -&nbsp;
                      </label>
                      <label
                        ><strong>
                          {{ shift.get("duration")?.value }}
                        </strong></label
                      >
                    </th>
                    <th id="tanque-ac-days-of-work">
                      <div
                        formGroupName="days"
                        class="d-flex flex-wrap gap-3 justify-content-center"
                      >
                        <div
                          *ngFor="let day of days"
                          class="text-center"
                          style="width: 10px"
                        >
                          <input
                            class="form-check-input"
                            type="checkbox"
                            [formControlName]="day.value"
                            [id]="'day-' + i + '-' + day.value"
                          />
                        </div>
                      </div>
                    </th>
                  </tr>
                </tbody>
              </table>
            </div>
          </form>
        </ng-template>
      </div>
    </div>
  </div>
</div>
